import { Button, Input, Space } from "antd";
import { Search } from "lucide-react";
import { FC, useEffect, useState } from "react";
import { useDebounceValue } from "~/hooks/use-debounce";
import { capitalize } from "~/utils";
import { ShuttleStatus } from "~/utils/constants";
import { useShuttleStore } from "../store/shuttle.store";
import { SearchOutlined } from "@ant-design/icons";

type Props = {};

export const FilterShuttles: FC<Props> = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [status, setStatus] = useState("all");

  const [search] = useDebounceValue(searchTerm, 500);

  const { setFilters } = useShuttleStore();

  useEffect(() => {
    let filters = {};

    if (status !== "all") {
      console.log("status", status);
      filters = {
        ...filters,
        status,
      };
    }

    filters = {
      ...filters,
      search,
    };
    setFilters(filters);
  }, [search, setFilters, status]);

  return (
    <Space size="middle">
      <Space size="small">
        {["all", ...Object.values(ShuttleStatus)].map((s) => (
          <Button
            key={s}
            size="small"
            className={`hover:bg-gray-100 ${
              status === s ? "bg-blue-100 text-blue-700" : ""
            }`}
            onClick={() => {
              setStatus(s as ShuttleStatus);
            }}
          >
            {capitalize(s)}
          </Button>
        ))}
      </Space>
      <Input
        type="text"
        placeholder="Search shuttles..."
        prefix={<SearchOutlined className="text-gray-400" />}
        className="w-48 rounded-lg"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <Search size={16} className="absolute left-3 top-3 text-gray-400" />
    </Space>
  );
};
